import { render, staticRenderFns } from "./TeacherQuestionAnswererLists.vue?vue&type=template&id=396dbb32&"
import script from "./TeacherQuestionAnswererLists.vue?vue&type=script&lang=js&"
export * from "./TeacherQuestionAnswererLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports